import { useCallback, useState } from 'react';
import { createManifest } from 'services/manifests.service';
import { downloadPDF } from 'services/pdf.service';
import prepareManifestData from 'modules/prepare-manifest-data/prepare-manifest-data';
import { getLabel } from 'services/pallets.service';
import { print } from 'services/printer.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import { useZebra } from 'context/ZebraProvider';
import { useAlert } from 'context/AlertProvider';
import { useApp } from 'context/AppProvider';

export function useGenerateManifest() {
  const { setInputFocus } = useApp();
  const zebra = useZebra();
  const alert = useAlert();
  const [requestingManifestDownload, setRequestingManifestDownload] =
    useState(false);

  const handleDownloadManifest = useCallback(
    async (agency_code, callback = () => {}) => {
      try {
        setRequestingManifestDownload(true);
        const { data: manifestData } = await createManifest(agency_code);
        if (!manifestData.packages?.length) {
          alert.current.error(
            'No puede generarse un nuevo pallet porque no hay nuevos artículos escaneados.',
          );
          return;
        }
        await downloadPDF(
          prepareManifestData(manifestData),
          'dropshipments-manifest',
        );

        try {
          const { data: palletLabel } = await getLabel(manifestData.pallet_id);
          await print(zebra, palletLabel?.content);
          await print(zebra, palletLabel?.content);
          setInputFocus();
        } catch (error) {
          alert.current.error('Error imprimiendo etiqueta de pallet');
          setRequestingManifestDownload(false);
        }
        setRequestingManifestDownload(false);
        callback();
      } catch (error) {
        alert.current.error(getMessageFromAxiosError(error));
        setRequestingManifestDownload(false);
      }
    },
    [setRequestingManifestDownload, alert, zebra, setInputFocus],
  );

  return { handleDownloadManifest, requestingManifestDownload };
}
